<template>
  <!-- 积分详情 -->
  <div class="integralDetail" style="padding-top: 0.49rem; height: 100%">
    <van-list
      class="ul"
      :style="{ background: finished ? 'none' : '#ffffff' }"
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      v-if="!isNone"
    >
      <div
        class="integralDetail_list"
        v-for="item in IntegralDetailsList"
        :key="item.id"
      >
        <div class="integralDetail_list_content">
          <div>
            <h2
              style="
                font-size: 0.16rem;
                font-weight: bold;
                color: #333333;
                margin-bottom: 0.08rem;
              "
            >
              {{ item.title }}
              <span v-show="item.money >= 0">【收入】</span>
              <span v-show="item.money < 0">【支出】</span>
            </h2>
            <div class="content_middle" style="margin-bottom: 0.08rem">
              <p
                style="
                  width: 2.66rem;
                  font-size: 0.14rem;
                  color: #333333;
                  line-height: 0.2rem;
                "
              >
                {{ item.mark }}
              </p>
              <p style="font-size: 0.18rem; color: #319f06">
                <span v-show="item.money >= 0">+{{ item.money }}</span
                ><span v-show="item.money < 0" style="color: #ff5d5d">{{
                  item.money
                }}</span>
              </p>
            </div>
          </div>
          <p style="font-size: 0.12rem; color: #999a9c; margin-bottom: 0.2rem">
            {{ item.ctime }}
          </p>
        </div>
        <div class="line"></div>
      </div>
    </van-list>
    <!-- 当积分详情时 -->
    <div
      v-if="isNone"
      class="noOrder"
      style="
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f1f4;
      "
    >
      <img
        src="../../assets/img/empty/img_blank_content@2x.png"
        alt=""
        style="width: 2.17rem; height: 1.75rem; margin-top: 1.8rem"
      />
      <p
        style="
          height: 0.24rem;
          font-size: 0.12rem;
          color: #99999b;
          line-height: 0.24rem;
        "
      >
        暂无内容
      </p>
    </div>
  </div>
</template>

<script>
import { getIntegralDetailsList } from '../../api/home'
export default {
  data () {
    return {
      IntegralDetailsList: [],
      loading: false,
      finished: false,
      page: 1,
      isNone: false
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      this.loading = true
      getIntegralDetailsList({ page: this.page })
        .then((res) => {
          this.IntegralDetailsList.push(...res.data.backdata.lists)
          this.page += 1
          this.loading = false
          if (res.data.backdata.lists == 0) {
            this.isNone = true
          } else {
            this.isNone = false
          }
          if (this.IntegralDetailsList.length >= res.data.ext.total) {
            this.finished = true
          }
        })
        .catch((err) => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang='scss'>
.integralDetail {
  .integralDetail_list {
    padding-left: 0.15rem;
    background: #ffffff;

    .integralDetail_list_content {
      width: 100%;
      min-height: 1.29rem;
      background: #ffffff;
      padding: 0.2rem 0.15rem 0 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .content_middle {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .line {
      width: 3.6rem;
      height: 0.01rem;
      background: #f3f1f4;
    }
  }
}
</style>
